import { getJson } from './apiClient';
import {
  normalizeList,
  pickFirst,
  toBool,
  toText,
} from './proyectosInmobiliariosUtils';

const BASE_URL = '/api/empresas/mis-permisos';

const normalizarEmpresaPermiso = (empresa = {}) => {
  const id = toText(pickFirst(empresa.empresaId, empresa.id, empresa.idEmpresa, empresa.Id));
  const rolEmpresa = toText(pickFirst(empresa.rolEmpresa, empresa.rol, empresa.rolUsuario, empresa.tipoRol), '').toUpperCase();

  return {
    ...empresa,
    id,
    empresaId: id,
    nombre: toText(pickFirst(empresa.nombre, empresa.nombreComercial, empresa.razonSocial, empresa.nombreEmpresa), id ? `Empresa ${id}` : 'Sin empresa'),
    rolEmpresa,
    puedeAdministrar: toBool(pickFirst(empresa.puedeAdministrar, rolEmpresa === 'ADMIN_EMPRESA'), rolEmpresa === 'ADMIN_EMPRESA'),
    activo: empresa.activo !== false && empresa.esActivo !== false,
  };
};

export const normalizarMisPermisosEmpresa = (data = {}) => {
  const empresas = normalizeList(pickFirst(data.empresas, data.data?.empresas, data.data, data))
    .map(normalizarEmpresaPermiso)
    .filter((empresa) => empresa.id && empresa.activo && empresa.rolEmpresa === 'ADMIN_EMPRESA' && empresa.puedeAdministrar);

  return {
    puedeAdministrarGlobal: data.puedeAdministrarGlobal === true,
    empresas,
  };
};

let permisosPromise = null;
let permisosPromiseKey = '';
let permisosCache = null;
let permisosCacheKey = '';

export const limpiarCacheMisPermisosEmpresa = () => {
  permisosPromise = null;
  permisosPromiseKey = '';
  permisosCache = null;
  permisosCacheKey = '';
};

export const obtenerMisPermisosEmpresa = async (options = {}) => {
  const cacheKey = String(options.cacheKey || '');

  if (permisosCache && permisosCacheKey === cacheKey && !options.forceRefresh) {
    return permisosCache;
  }

  if (!permisosPromise || permisosPromiseKey !== cacheKey || options.forceRefresh) {
    permisosPromiseKey = cacheKey;
    permisosPromise = getJson(BASE_URL, {
      signal: options.signal,
      suppressForbiddenAlert: true,
    })
      .then((data) => {
        permisosCache = normalizarMisPermisosEmpresa(data);
        permisosCacheKey = cacheKey;
        return permisosCache;
      })
      .finally(() => {
        permisosPromise = null;
        permisosPromiseKey = '';
      });
  }

  return permisosPromise;
};
